
import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
  name: 'catalog-product-list-toolbar-paginator',
})
export default class extends Vue {
  @Prop({required: true}) private dataSource: string;
  @Prop({default: 2}) private interval: number;

  private get currentPage(): number {
    return Number(this.$store.getters[`${this.dataSource}/currentPage`]);
  }

  private get totalPages(): number {
    return Number(this.$store.getters[`${this.dataSource}/totalPages`]);
  }

  private get lastPage(): number {
    return Number(this.$store.getters[`${this.dataSource}/totalPages`]);
  }

  private get paginationPages(): Array<number> {
    let pages = [];
    for (let i = this.paginationStart; i <= this.paginationEnd; i++) {
      pages.push(i);
    }
    return pages;
  }

  private get paginationStart(): number {
    return this.currentPage <= this.interval ? 1 : this.currentPage - this.interval;
  }

  private get paginationEnd(): number {
    if (this.currentPage + this.interval < this.totalPages) {
      return this.currentPage + this.interval;
    }

    return this.totalPages;
  }

  private createUrl(page): string {
    const url: URL = new URL(window.location.href);

    url.searchParams.set('page', page);

    return url.toString();
  }

  private updatePage(page): void {
    if (page === this.currentPage) {
      return;
    }

    this.$store.dispatch(`${this.dataSource}/updatePage`, page);

    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  private get totalProductCount(): number {
    return this.$store.getters[`${this.dataSource}/totalItemCount`];
  }
}
